import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/contact/page.tsx");
